import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Asset';

const routes = [
    {
        matchRegex: '/Asset',
        name: getRouteName(MODULE_NAME, 'Listing'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDListlImg,
    },
    {
        matchRegex: '/Asset/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_RIGHT_SECTION_FORM,
            SLOT_KEY.SLOT_SCRIPTS,
        ],
        image: PreviewDetailImg,
    },
]

export default routes;